export default (blob, nameFile) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  
  a.href = url;
  a.download = nameFile;

  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};